export default __webpack_public_path__ + "static/media/news247122.bdf90041.webp";